module.exports = __webpack_public_path__ + "img/new_index_cases8.5f1dc3c9.png";